/**
 * Created by jmulder on 21/10/16.
 */


export class User {

    constructor(
        public $key: string,
        public club: string,
        public name: string,
        public email: string,
        public phone: string,
        public role: string = "none",
        public lastLoggedIn: string,
        public refreshToken: string,
        public userId: string,
        public intensity?: number,
        public distributorCode?: number
    ) {
    }

    static fromJson({$key, club, name, email, phone, role, lastLoggedIn, refreshToken, userId, intensity, distributorCode}) {
        return new User($key, club, name, email, phone, role, lastLoggedIn, refreshToken, userId, intensity, distributorCode);
    }

    static fromJsonArray(json : any[]) : User[] {
        return json.map(User.fromJson);
    }

}
